import "./buttons.css";
import nextArrow from "@/assets/next-arrow.png";

type ButtonProps = {
  onClick?: () => void;
  className?: string;
};

const NextButton: React.FC<ButtonProps> = ({ onClick, className }) => {
  return (
    <button className={`next-button ${className}`} onClick={onClick} aria-label="Next">
      <img src={nextArrow} alt="" />
    </button>
  );
};

export default NextButton;
